/*
  Adventsonntage – Countdown bis Vorbestellschluss (sections/ec-advent-deadline.liquid)
  Gerechnet wird im Browser, weil Shopify Seiten zwischenspeichert; Liquid zeigt nur das Datum.
  Die Ziffern laufen still mit, Screenreader hören höchstens einmal pro Minute davon.
  Bei Ablauf schaltet assets/ec-advent.js die Seite auf „vergeben“.
*/
(function () {
  if (window.ECAdventCountdown) return;
  window.ECAdventCountdown = true;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function run(el) {
    var end = Date.parse(el.getAttribute('data-adv-countdown'));
    if (isNaN(end)) return;
    var days = el.querySelector('[data-unit="days"]');
    var hours = el.querySelector('[data-unit="hours"]');
    var minutes = el.querySelector('[data-unit="minutes"]');
    var live = el.querySelector('[data-adv-live]');
    var template = live ? live.getAttribute('data-template') : '';
    var lastMinute = -1;
    var timer = 0;

    function tick() {
      var left = Math.max(0, end - Date.now());
      var total = Math.floor(left / 60000);
      var d = Math.floor(total / 1440);
      var h = Math.floor((total % 1440) / 60);
      var m = total % 60;
      if (days) days.textContent = d;
      if (hours) hours.textContent = pad(h);
      if (minutes) minutes.textContent = pad(m);
      if (live && total !== lastMinute) {
        lastMinute = total;
        live.textContent = template.replace('[d]', d).replace('[h]', h).replace('[m]', m);
      }
      if (left <= 0) {
        clearInterval(timer);
        if (window.ECAdvent) window.ECAdvent.close();
        else document.documentElement.classList.add('ec-adv-closed');
      }
    }

    el.hidden = false;
    tick();
    timer = setInterval(tick, 10000);
  }

  function init() {
    document.querySelectorAll('[data-adv-countdown]').forEach(run);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
